// pages/public/LandingPage.jsx
// Charge et affiche la landing page statique (landing.html)
// Le HTML est injecté via dangerouslySetInnerHTML pour préserver
// les scripts, styles et animations de la landing

import { useEffect } from 'react';

export default function LandingPage() {
  useEffect(() => {
    // Charger le HTML de la landing
    fetch('/landing.html')
      .then(r => r.text())
      .then(html => {
        // Remplacer tout le document
        document.open();
        document.write(html);
        document.close();
      })
      .catch(() => {
        // Fallback : rediriger vers login si landing non disponible
        window.location.href = '/login';
      });
  }, []);

  // Afficher un écran de chargement le temps que le HTML se charge
  return (
    <div style={{
      minHeight: '100vh',
      background: '#07080d',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <div style={{
        width: 32, height: 32,
        border: '3px solid rgba(124,92,252,0.2)',
        borderTop: '3px solid #7c5cfc',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
      }}/>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
